import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { WizardSteps } from '../components/promotions/wizard/WizardSteps';
import { Step1InfosPromotion } from '../components/promotions/wizard/Step1InfosPromotion';
import { Step2ConfigBlocs } from '../components/promotions/wizard/Step2ConfigBlocs';
import { Step3GenerationLots } from '../components/promotions/wizard/Step3GenerationLots';
import Step4PhotosDocuments from '../components/promotions/wizard/Step4PhotosDocuments';
import Step5Recap from '../components/promotions/wizard/Step5Recap';

const STEPS = [
  { number: 1, name: 'Infos générales' },
  { number: 2, name: 'Blocs' },
  { number: 3, name: 'Lots' },
  { number: 4, name: 'Photos' },
  { number: 5, name: 'Publication' },
];

interface BlockData {
  block_name: string;
  block_order: number;
  total_floors: number;
  elevators_count: number;
  studio_count: number;
  f2_count: number;
  f3_count: number;
  f4_count: number;
  f5_count: number;
  duplex_count: number;
  triplex_count: number;
  commercial_count: number;
}

interface FormData {
  name: string;
  address: string;
  city: string;
  wilaya: string;
  promoter_name: string;
  promoter_phone: string;
  promoter_email: string;
  delivery_date: string;
  construction_progress: number;
  description: string;
  blocks: BlockData[];
  units: any[];
  photos: string[];
  master_plan_url?: string;
  brochure_url?: string;
  typePhotos?: {
    f2: string[];
    f3: string[];
    f4: string[];
    f5: string[];
  };
  status: string;
  is_published: boolean;
  publish_dar_dz: boolean;
}

export const AddPromotionPage: React.FC = () => {
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState<FormData>({
    name: '',
    address: '',
    city: '',
    wilaya: '',
    promoter_name: '',
    promoter_phone: '',
    promoter_email: '',
    delivery_date: '',
    construction_progress: 0,
    description: '',
    blocks: [],
    units: [],
    photos: [],
    master_plan_url: '',
    brochure_url: '',
    typePhotos: {
      f2: [],
      f3: [],
      f4: [],
      f5: [],
    },
    status: 'draft',
    is_published: false,
    publish_dar_dz: false,
  });

  const handleNext = () => {
    if (currentStep < 5) {
      setCurrentStep(currentStep + 1);
    }
  };

  const handleBack = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  const updateFormData = (data: Partial<FormData>) => {
    setFormData({ ...formData, ...data });
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-8">
      <div className="max-w-4xl mx-auto px-4">
        <WizardSteps steps={STEPS} currentStep={currentStep} />

        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6 mt-6">
          {currentStep === 1 && (
            <Step1InfosPromotion
              data={formData}
              onUpdate={updateFormData}
              onNext={handleNext}
              onCancel={() => navigate('/promotions')}
            />
          )}

          {currentStep === 2 && (
            <Step2ConfigBlocs
              data={formData}
              onUpdate={updateFormData}
              onNext={handleNext}
              onBack={handleBack}
            />
          )}

          {currentStep === 3 && (
            <Step3GenerationLots
              data={formData}
              onUpdate={updateFormData}
              onNext={handleNext}
              onBack={handleBack}
            />
          )}

          {currentStep === 4 && (
            <Step4PhotosDocuments
              data={formData}
              onUpdate={updateFormData}
              onNext={handleNext}
              onBack={handleBack}
            />
          )}

          {currentStep === 5 && (
            <Step5Recap
              data={formData}
              onBack={handleBack}
            />
          )}
        </div>
      </div>
    </div>
  );
};
